<template @keyup.esc="closeEverything">
    <div id="data-list-thumb-view" class="data-list-container">
        <vs-table ref="table" :max-items="20" pagination search :data="vehicles">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <h1>Hebtrek middelen</h1>
                <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="openCreateVehiclePopup"
                >Middel toevoegen
<!--                    <span class="ml-2 text-base text-primary" @click="openCreateInvoiceableModal">Toevoegen</span>-->
                </div>
            </div>
            <template slot="thead">
                <vs-th sort-key="entity-id">Id</vs-th>
                <vs-th sort-key="company_name">Type</vs-th>
                <vs-th sort-key="phone_number">Status</vs-th>
                <vs-th sort-key="phone_number">Naam</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr
                        :data="vehicle"
                        :key="index"
                        v-for="(vehicle, index) in data"
                        @click.native="openVehiclePopup(vehicle)"
                >
                    <vs-td>
                        <p class="entity-id">{{ vehicle._id }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="vehicle-status">{{ vehicle.type }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="vehicle-status">{{ vehicle.status }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="vehicle-license_plate">{{ vehicle.name }}</p>
                    </vs-td>

                    <vs-td >
                        <p class="deliverer-phone_number"> <vs-button
                                color="danger"
                                type="flat"
                                ref="loadableButton"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                @click.stop="startDelete(vehicle)"
                        ></vs-button></p>
                    </vs-td>


                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <ht-vehicle-popup></ht-vehicle-popup>
    </div>
</template>
<script>

    import VehiclePopup from "./VehiclePopup";
    export default {

        data() {
            return {
                selected: [],
                vehicles: [],
            };
        },

        components: {
            "ht-vehicle-popup": VehiclePopup
        },

        methods: {
            getVehicles() {
                this.$http.get('/v1/vehicles')
                    .then((response) => {
                        this.vehicles = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },

            startDelete(entity) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: 'Weet je het zeker?',
                    acceptText: 'Jazeker',
                    cancelText: 'No I want my Mommy',
                    text: 'Hiermee verwijder je ' + entity.name,
                    accept: function() {
                        this.loading = true;
                        let data = new FormData();
                        data.append('_method', 'DELETE');
                        data.append('id', entity._id);
                        this.$http
                            .post("v1/vehicle/delete", data, {
                                headers: {
                                    Authorization:
                                        "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                                },
                            })
                            .then(() => {
                                this.loading = false;
                                this.$events.fire('refresh-vehicles');
                                this.$util.notify('Gelukt', 'Entiteit is verwijderd!', this.$vs);
                            })
                            .catch((error) => {
                                this.$vs.loading.close("#delete-invoiceable-button > .con-vs-loading");
                                this.loading = false;
                                this.$util.logError(error, this.$vs);
                            });
                    }
                })
            },


            openVehiclePopup(vehicle) {
                this.$events.fire('open-vehicle-modal', vehicle);
            },

            openCreateVehiclePopup() {
                this.$events.fire('open-create-vehicle-modal');

            }

        },

        mounted() {
            this.getVehicles();
            this.$events.listen('refresh-vehicles', () => {
                this.getVehicles();
            });
        }
    };
</script>
